// 全局消息提示配置文件
let msgCfg = {
};

// 系统异常
msgCfg.sysErr = "系统内部错误";

msgCfg.WEV6022W="只能选中一条数据复制新增";
msgCfg.WEV6031W="请选择要删除的数据";
msgCfg.WEV6024W="请选择要保存的数据";
msgCfg.WEV6032W="删除成功";

//代码维护
msgCfg.WEV6057W="该代码已存在";
msgCfg.WEV6058W="该代码名称已存在";
msgCfg.WEV6059W="代码不能为空";
msgCfg.WEV6060W="代码名称不能为空";
msgCfg.WEV6061W="代码不能设置重复";
msgCfg.WEV6062W="代码名称不能设置重复";
msgCfg.WEV6090W="该代码类型必须保留一条数据可用";
//工厂日历

//产线工作日历
msgCfg.WEV6078W="结束日期不能为空";
msgCfg.WEV6079W="开始日期不能大于结束日期";
msgCfg.WEV6080W="日程安排不能为空";
msgCfg.WEV6081W="日程安排为停机时，停机原因不能为空";
msgCfg.WEV6086W="年份不能为空";
msgCfg.WEV6087W="起始年月不能为空";
msgCfg.WEV6088W="车间不能为空";
msgCfg.WEV6089W="产线不能为空";

//月度生产计划调整
//年度生产计划调整
msgCfg.WEV6099W="计划生产日期(开始)不能为空";
msgCfg.WEV6100W="计划生产日期（结束）不能为空";
msgCfg.WEV6101W="版本号不能为空";
msgCfg.WEV6102W="请选择版本号";
msgCfg.WEV6103W="计划生产日期不能为空";
msgCfg.WEV6104W="计划生产数量不能为空";
msgCfg.WEV6105W="规格不能为空";
msgCfg.WEV6106W="税别不能为空";
msgCfg.WEV6107W="包装袋不能为空";
msgCfg.WEV6108W="托盘不能为空";
msgCfg.WEV6109W="品名不能为空";
msgCfg.WEV6179W="只能调整系统日之后的生产计划";
msgCfg.WEV6194W="检索条件的版本号和明细第一行的版本号不一致，请确认";
msgCfg.WEV6195W="计划生产日期(开始)不能大于计划生产日期(结束)";

//品目库存推移明细
msgCfg.WEV6174W="规格/税别/包装袋/托盘 不能为空";
msgCfg.WEV6175W="开始日期不能为空";





export default msgCfg;



// WEBPACK FOOTER //
// ./src/config/msg.js